// The first shipped piece of the protocol: collaborative playlists built
// from the links people already send each other.

import { Reveal } from '../components/Reveal';
import { Arrow } from '../components/Atoms';

export const PLAYLIST_URL = 'https://playlist.furtif.fm';

export function Playlists() {
  return (
    <section className="block" id="playlists" data-screen-label="05 Playlists">
      <div className="wrap">
        <div className="sec-head">
          <div><div className="sec-num"><b>05</b> &nbsp; en écoute</div></div>
          <div className="sec-tag">DISPONIBLE — 05</div>
        </div>

        <Reveal as="h2" className="sec-title">
          La première brique <em>tourne déjà.</em>
        </Reveal>
        <Reveal as="p" className="sec-intro">
          Avant le fil, il y a le geste : ces liens qu'on s'envoie dans une conversation et
          qui s'y perdent. <a className="ulink" href={PLAYLIST_URL}>playlist.furtif.fm</a> les
          rassemble en une playlist commune — chacun l'écoute sur sa propre plateforme.
          C'est le protocole en réduction, et il est ouvert à tous.
        </Reveal>

        <div className="pillars">
          <Reveal className="pillar">
            <span className="num">01 — capture</span>
            <div className="word">Poster</div>
            <h3>rien de neuf à apprendre</h3>
            <p>
              Un bot rejoint votre groupe. Vous continuez à partager des liens comme
              d'habitude, il les reconnaît et les range.
            </p>
            <div className="meta">→ Telegram · Deezer, Spotify, Apple Music, YouTube…</div>
          </Reveal>
          <Reveal className="pillar" delay={80}>
            <span className="num">02 — traduction</span>
            <div className="word">Traverser</div>
            <h3>chacun sur sa plateforme</h3>
            <p>
              Chaque morceau est normalisé puis reproposé partout où il existe. Vous
              choisissez la vôtre une fois, la page s'en souvient.
            </p>
            <div className="meta">→ le même pipeline ISRC que le fil</div>
          </Reveal>
          <Reveal className="pillar" delay={160}>
            <span className="num">03 — sobriété</span>
            <div className="word">Oublier</div>
            <h3>les liens, rien d'autre</h3>
            <p>
              Le bot ne conserve que les liens musicaux. Pas de compte, pas de mot de
              passe, pas d'adresse e-mail.
            </p>
            <div className="meta">→ le reste ne quitte pas la conversation</div>
          </Reveal>
        </div>

        <Reveal as="blockquote" className="pl-quote">
          <em>écoute ça.</em>
          <span className="pl-quote-note">
            Deux mots qu'on s'envoie depuis toujours. furtif se contente de les garder.
          </span>
        </Reveal>

        <Reveal className="pl-cta">
          <a href={PLAYLIST_URL} className="btn">Créer une playlist <Arrow /></a>
          <a href={`${PLAYLIST_URL}/#raccourci`} className="ulink">Le raccourci iPhone &nbsp;→</a>
        </Reveal>
      </div>
    </section>
  );
}
